import * as React from 'react';
import { SVGProps } from 'react';

const IconChatFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.469 1c2.445.143 4.387 2.071 4.531 4.5v.286c0 .714-.144 1.5-.504 2.143-.79 1.642-2.445 2.642-4.315 2.642a5.435 5.435 0 0 1-1.87-.357L1.866 11h-.144a.655.655 0 0 1-.503-.214c-.216-.215-.288-.5-.144-.715l.791-2.428c-.288-.643-.36-1.214-.36-1.857C1.506 4 2.513 2.357 4.167 1.5c.648-.357 1.367-.5 2.086-.5h.216Z"
    />
  </svg>
);
export default IconChatFilledSizeXs;
